import { Component } from '@angular/core';
import { SharedService } from '../../../services/shared.service';
import { SelectionService } from '../../../services/select.service';
import { io } from 'socket.io-client';
@Component({
  selector: 'app-remote',
  standalone: false,
  template: `<div class="p-3"><div *ngFor="let message of shareObject.messages;let index=index;">{{index+1}}: {{message}}</div></div>`,
})
export class RemoteComponent {
  public shareObject: any = { messages: [`Setup remote connection`], room: 'test' };
  constructor(
    private shareService: SharedService,
  ) {
  }
  ngOnInit(): void {
    this.shareObject.socket = io(new URL(this.shareService.env.apiUrl).origin);
    this.shareObject.socket.on('connect', () => {
      this.shareObject.socket.emit('remote.join-room', this.shareObject.room);
      this.shareObject.messages.push(`Connected to server`);
    });
    this.shareObject.peerConnection = new RTCPeerConnection();
    this.shareObject.peerConnection.onconnectionstatechange = () => {
      this.shareObject.messages.push(`Connection state: ${this.shareObject.peerConnection.connectionState}`);
    };
    this.shareObject.peerConnection.oniceconnectionstatechange = () => {
      this.shareObject.messages.push(`ICE connection state: ${this.shareObject.peerConnection.iceConnectionState}`);
    };
    this.setupRemote().then(() => {
      this.shareObject.messages.push(`Remote setup complete`);
      this.startRemote(this.shareObject.displays.pop(), this.shareObject.room).then(() => {
        this.shareObject.messages.push(`Remote started`);
      }).catch((error: any) => {
        this.shareObject.messages.push(`Error starting remote: ${error.message}`);
      });
    });
  }
  async setupRemote() {
    try {
      this.shareObject.sources = await (window as any).require("electron").ipcRenderer.invoke("get_displays");
      this.shareObject.displays = this.shareObject.sources.filter((s: any) => s.id.startsWith("screen:"));
      this.shareObject.messages.push(`Found ${this.shareObject.displays.length} displays`);
    } catch (error: any) {
      this.shareObject.messages.push(`Error getting displays: ${error.message}`);
    }
  }
  async startRemote(display: any, roomId: string) {
    this.shareObject.messages.push(`Starting remote ${display.id}`);
    try {
      this.shareObject.stream = await (navigator as any).mediaDevices.getUserMedia({ audio: false, video: { mandatory: { chromeMediaSource: 'desktop', chromeMediaSourceId: display.id } } });
      this.shareObject.stream.getTracks().forEach((track: MediaStreamTrack) => {
        this.shareObject.peerConnection.addTrack(track, this.shareObject.stream);
        console.log(track);
      });
      // this.shareObject.peerConnection.addStream(this.shareObject.stream);
      this.shareObject.peerConnection.onicecandidate = (e: any) => {
        if (e.candidate) {
          this.shareObject.socket.emit('remote.ice-candidate', e.candidate, roomId);
        }
      };
      let offer = await this.shareObject.peerConnection.createOffer();
      await this.shareObject.peerConnection.setLocalDescription(offer);
      this.shareObject.socket.emit('remote.offer', offer, roomId);
      this.shareObject.socket.on('remote.answer', async (answer: any) => {
        await this.shareObject.peerConnection.setRemoteDescription(answer);
      });
      this.shareObject.socket.on('remote.ice-candidate', async (candidate: any) => {
        await this.shareObject.peerConnection.addIceCandidate(candidate);
      });
    } catch (error: any) {
      this.shareObject.messages.push(`Error starting remote: ${error.message}`);
    }
  }
}
